{ keyword: this.keyword }

async searchCareer({}, query) {
      const { data: careers } = await Get(
        `${ApiPath.Onet}/searchcareer`,
        query
      );
      return careers;
    },<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5 class="dashboard-title">Search Career</h5>
        <div class="ts-app-shell--header_actions flexed">
          <button class="ts-btn ts-btn-small" @click="back">Back</button>
        </div>
      </div>
      <p>
        Thinking about a change? Want to learn about a new job or a new career?
        <br />
        You can compare your current skills to any job! Your future starts here
        with the Skills Passport.
      </p>
      <br /><br />
      <el-row container :gutter="24">
        <!-- <column :xs=12>test</column> -->
        <el-col :xs="24" :md="9" :lg="9">
          <div>
            <el-input
              type="text"
              v-model="keyword"
              placeholder="Search job title here.."
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="search"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row container :gutter="24" v-if="careers.length != 0">
        <el-col :xs="24" :md="24" :lg="24">
          <br /><br />
          <el-table
            :data="careers"
            stripe
            style="cursor: pointer"
            class="ts-notifications-table"
          >
            <el-table-column
              width="auto"
              :label="
                'Showing top 20 careers for ' +
                keywordresult +
                '. Closest matches are shown first.'
              "
            >
              <template scope="scope">
                <span
                  style="color: #00c8dc; word-break: break-word"
                  @click="gotoDetails(scope.row)"
                  >{{ scope.row.title }}</span
                >
              </template>
            </el-table-column>
          </el-table>
          <br /><br />
        </el-col>
      </el-row>

      <el-row container v-else>
        <el-col>
          <br /><br />
          <div class="no-data">
            <span> {{ this.noResultMessage }}</span>
          </div>
        </el-col>        
      </el-row>
    </div>

    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    TSLoading,
  },
  created() {
    this.role = this.$route.meta.role;
  },
  computed: {
    applicantUserInfo() {
      return this.$store.state.account.applicant_user_info
    }
  },
  data() {
    return {
      keyword: null,
      keywordresult: null,
      careers: [],
      loading: false,
      role: null,
      noResultMessage: null
    };
  },
  methods: {
    back() {
      if (this.applicantUserInfo.apprenticeId) {
        this.$router.push({ name: "ApprenticeSkillsPassport" });
      } else if (this.applicantUserInfo.jobSeekerId) {
        this.$router.push({ name: "JobSeekerSkillsPassport" });
      }
    },
    search() {
      if (this.keyword == "" || this.keyword == null) {
        this.$confirm("Please enter keyword to search", "Warning", {
          confirmButtonText: "OK",
          type: "warning",
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          center: true,
        }).then(() => {
          return false;
        });
        return false;
      } else {
        this.loading = true;
        this.$store
          .dispatch('onet/searchCareerPassport', { keyword: this.keyword })
          .then((res) => {
            this.keywordresult = this.keyword;
            this.careers = res.career || [];

            if(this.careers.length == 0 ) this.noResultMessage = 'No Result';
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    gotoDetails(row) {
      if (this.applicantUserInfo.apprenticeId) {
        this.$router.push({
          name: "ApprenticeSkillsPassportDetails",
          params: { onetcode: row.code },
        });
      } else if (this.applicantUserInfo.jobSeekerId) {
        this.$router.push({
          name: "JobSeekerSkillsPassportDetails",
          params: { onetcode: row.code },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-message-box__message p {
  text-align: center;
}

.no-data {
  margin-top: 100px;
  text-align: center;
  color: gray;
  font-size: 18px;
  font-weight: bold;
}
</style>
